import { render, staticRenderFns } from "./FreeRoundSelectorNew.vue?vue&type=template&id=3a3ae8e9&scoped=true&"
import script from "./FreeRoundSelectorNew.vue?vue&type=script&lang=js&"
export * from "./FreeRoundSelectorNew.vue?vue&type=script&lang=js&"
import style0 from "./FreeRoundSelectorNew.vue?vue&type=style&index=0&id=3a3ae8e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3ae8e9",
  null
  
)

export default component.exports